import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-flexbox-grid';
import { translate } from 'react-i18next';
import Table from 'antd/lib/table';
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import Radio from 'antd/lib/radio';
import Tooltip from 'antd/lib/tooltip';
import { ResponsiveTable } from '../../../common/components/data-display';
import {
  currencyFormatter,
  formatMonthsQuantity,
  formatMonthsCount,
  percentageFormatter,
  tranaslatedDistanceInWordsToNow,
} from '../../../common/utils/helpers';
import config from '../../../config';
import { loanGoalsT } from '../../../common/enums';
import allocationRules from '../../../common/rules/allocationRules';
import rules from '../../../common/rules/rules';
import { paymentDestinationT } from '../../../common/enums';
import DurationFilter from './filters/Duration';
import AmountFilter from './filters/Amount';
import InterestFilter from './filters/Interest';
import RemainingAmountFilter from './filters/RemainingAmount';

const Column = Table.Column;
const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

@translate()
@Form.create()
export default class CreateManualAllocationDesktop extends Component {
  static propTyes = {
    accountBalance: PropTypes.number.isRequired,
    expandedRowKeys: PropTypes.array.isRequired,
    expectedRevenues: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    isCreating: PropTypes.bool.isRequired,
    isFetchingLoans: PropTypes.bool.isRequired,
    loans: PropTypes.array.isRequired,
    onAllocationAmountChange: PropTypes.func.isRequired,
    onRowClick: PropTypes.func.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    onResetFilters: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    pagination: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    validateAndSubmit: PropTypes.func.isRequired,
  };

  render() {
    const {
      accountBalance,
      expandedRowKeys,
      expectedRevenues,
      form,
      loans,
      onAllocationAmountChange,
      onRowClick,
      onTableChange,
      pagination,
      t,
      validateAndSubmit,
      filter,
      onFilterChange,
      onResetFilters,
      minMonths,
      maxMonths
    } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <div>
        <div className="manual-allocation-filters">
          <Row>
            <Col xs={12}>
              <DurationFilter onChange={onFilterChange} value={filter.termMonthsMin} minMonths={minMonths} maxMonths={maxMonths} />
            </Col>
            <Col xs={12} sm={4}>
              <AmountFilter
                min={config.manualAllocationFilterSettings.amountMin}
                max={config.manualAllocationFilterSettings.amountMax}
                step={config.manualAllocationFilterSettings.amountStep}
                onChange={onFilterChange}
                value={[filter.amountMin, filter.amountMax]}
              />
            </Col>
            <Col xs={12} sm={4}>
              <InterestFilter
                min={config.manualAllocationFilterSettings.interestMin}
                max={config.manualAllocationFilterSettings.interestMax}
                step={config.manualAllocationFilterSettings.interestStep}
                onChange={onFilterChange}
                value={[filter.interestMin, filter.interestMax]}
              />
            </Col>
            <Col xs={12} sm={4}>
              <RemainingAmountFilter
                min={config.manualAllocationFilterSettings.remainingAmountMin}
                max={config.manualAllocationFilterSettings.remainingAmountMax}
                step={config.manualAllocationFilterSettings.remainingAmountStep}
                onChange={onFilterChange}
                value={[filter.remainingAmountMin, filter.remainingAmountMax]}
              />
            </Col>
          </Row>
          <Row center="xs">
            <Col xs={3}>
              <Button size="small" onClick={onResetFilters}>
                {t('Resetovať filtre')}
              </Button>
            </Col>
          </Row>
        </div>

        <ResponsiveTable
          dataSource={loans}
          expandedRowKeys={expandedRowKeys}
          onChange={onTableChange}
          onExpand={(expanded, loan) => onRowClick(loan)}
          onRowClick={onRowClick}
          pagination={pagination}
          rowKey={loan => loan.id}
          expandedRowRender={loan => (
            <Form className="manual-allocation-detail">
              <Row>
                <Col xs={12} sm={6}>
                  <FormItem label={t('Suma')}>
                    {getFieldDecorator(`amount[${loan.id}]`, {
                      rules: allocationRules.amountFitsInAccoutBalance(
                        form,
                        accountBalance,
                        loan.remainingAmount
                      ),
                      initialValue: loan.remainingAmount
                    })(
                      <Input
                        size="default"
                        disabled={true}
                      />
                    )}
                  </FormItem>
                </Col>
                <Col xs={12} sm={6} className="right-col">
                  <Button
                    onClick={() => validateAndSubmit(loan, form)}
                    htmlType="submit"
                    type="danger"
                  >
                    {t('Investovať')}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        >
          <Column
            title={t('ID')}
            dataIndex="loanNumber"
            key="loanNumber"
            render={loanNumber => loanNumber}
          />
          <Column
            title={t('Typ pôžičky')}
            dataIndex="goal"
            key="goal"
            render={goal => (
              <span>
                {t('na')} "{loanGoalsT[goal]}"
              </span>
            )}
          />
          <Column
            title={t('Suma pôžičky')}
            dataIndex="amount"
            key="amount"
            render={amount => currencyFormatter(amount)}
          />
          <Column
            title={t('Výnos p.a.')}
            dataIndex="interest"
            key="interest"
            render={interest => percentageFormatter(interest)}
          />
          <Column
            title={t('Splatnosť')}
            dataIndex="months"
            key="months"
            render={months => `${formatMonthsCount(months)} ${formatMonthsQuantity(months)}`}
          />
          <Column
            title={t('Do zaplnenia')}
            dataIndex="remainingAmount"
            key="remainingAmount"
            render={remainingAmount => currencyFormatter(remainingAmount)}
          />
          <Column
            title={t('Ostáva')}
            dataIndex="expirationDate"
            key="expirationDate"
            render={expirationDate => tranaslatedDistanceInWordsToNow(expirationDate)}
          />
        </ResponsiveTable>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocations/components/CreateManualAllocationDesktop.js